<template>
    <div style="margin-top: 48px">
        <div class="page-header pr-0">
            <h2>
                <a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a>
            </h2>
            <ol class="breadcrumbs">
                <li class="active"><span>VISTA GENERAL RECEPCIÓN</span></li>
            </ol>
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Vista general recepción</h3>
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3 col-sm-12">
                        <x-select v-model="hotel_floor_id"
                                  label="Piso"
                                  :options="floors"
                                  @input="searchRooms"></x-select>
                    </div>
                    <div class="col-md-9 col-sm-12">
                        <x-input v-model="hotel_name_room"
                                 label="Buscar por nombre de habitación"
                                 @input="searchRooms"></x-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <el-radio-group v-model="hotel_status_room"
                                        @change="searchRooms"
                                        fill="#007bff">
                            <el-radio-button v-for="st in roomStatus"
                                             :key="st"
                                             :label="st"></el-radio-button>
                            <!--                            <el-radio-button label="Washington"></el-radio-button>-->
                            <!--                            <el-radio-button label="Los Angeles"></el-radio-button>-->
                            <!--                            <el-radio-button label="Chicago"></el-radio-button>-->
                        </el-radio-group>

                        <!--                        <el-button-group>-->
                        <!--                            <el-button v-for="st in roomStatus"-->
                        <!--                                       :key="st"-->
                        <!--                                       :class="onGetColorStatus(st)"-->
                        <!--                                       :disabled="loading"-->
                        <!--                                       class="btn btn-sm"-->
                        <!--                                       size="mini"-->
                        <!--                                       @click="onFilterByStatus(st)">{{ st }}-->
                        <!--                            </el-button>-->
                        <!--                        </el-button-group>-->
                    </div>
                </div>
                <div class="row">
                    <div v-for="ro in items"
                         :key="ro.id"
                         class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-4">
                        <x-hotel-room :room="ro"
                                      @action="clickRoom(ro)"
                                      @click-add-item="onGoToAddProducts(ro)"
                                      @click-extend-time-room="showDialogExtendTimeRoom(ro)"></x-hotel-room>
                        <!--                        <div style="display: flex; flex-direction: column; border-radius: 8px; height: 140px" :class="onGetColorStatus(ro.status)">-->
                        <!--                            <div style="display: flex; height: 130px">-->
                        <!--                                <div class="flex-grow-1"-->
                        <!--                                     style="display: flex; align-items: flex-start;justify-content: flex-start; font-size: 32px; font-weight: bold;  padding: 24px 16px;">-->
                        <!--                                    {{ ro.name }}-->
                        <!--                                </div>-->
                        <!--                                <div style="font-size: 48px; display: flex; align-items: center; justify-content: center; padding: 16px">-->
                        <!--                                    <i class="fal fa-bed-alt"></i>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                            <div style="background-color: rgba(0, 0, 0, .1); text-align: center; font-size: 16px">{{ ro.status }}</div>-->
                        <!--                        </div>-->
                        <!--                        <el-card :class="onGetColorStatus(ro.status)"-->
                        <!--                                 style="min-height: 160px">-->
                        <!--                            <div slot="header"-->
                        <!--                                 class="d-flex align-items-center justify-content-between">-->
                        <!--                                <span>{{ ro.status }}: {{ ro.name }}</span>-->
                        <!--                                <template v-if="ro.status === 'LIMPIEZA'">-->
                        <!--                                    <el-button :disabled="loading"-->
                        <!--                                               :loading="loading"-->
                        <!--                                               style="margin-left: auto"-->
                        <!--                                               title="Ir al checkout"-->
                        <!--                                               type="primary"-->
                        <!--                                               @click="onFinalizeClean(ro)">-->
                        <!--                                        <i class="fa fa-broom"></i>-->
                        <!--                                    </el-button>-->
                        <!--                                </template>-->
                        <!--                                <template v-if="ro.status === 'OCUPADO'">-->
                        <!--                                    <el-button style="margin-left: auto"-->
                        <!--                                               title="Ir al checkout"-->
                        <!--                                               type="primary"-->
                        <!--                                               @click="onGoToCheckout(ro)">-->
                        <!--                                        <i class="fa fa-arrow-circle-right"></i>-->
                        <!--                                    </el-button>-->
                        <!--                                    <el-button style="margin-left: 0.5rem"-->
                        <!--                                               title="Agregar productos"-->
                        <!--                                               type="primary"-->
                        <!--                                               @click="onGoToAddProducts(ro)">-->
                        <!--                                        <i class="fa fa-plus-circle"></i>-->
                        <!--                                    </el-button>-->
                        <!--                                    <el-button style="margin-left: 0.5rem"-->
                        <!--                                               title="Extender Tiempo"-->
                        <!--                                               type="primary"-->
                        <!--                                               @click="ShowDialogExtendTimeRoom(ro)">-->
                        <!--                                        <i class="fa fa-plus"></i>-->
                        <!--                                    </el-button>-->
                        <!--                                </template>-->
                        <!--                                <el-button-->
                        <!--                                    v-if="ro.status === 'DISPONIBLE'"-->
                        <!--                                    type="primary"-->
                        <!--                                    @click="onToRent(ro)">-->
                        <!--                                    <i class="fa fa-arrow-circle-left"></i>-->
                        <!--                                </el-button>-->
                        <!--                            </div>-->
                        <!--                            <div-->
                        <!--                                v-if="ro.status === 'DISPONIBLE'"-->
                        <!--                                class="d-flex justify-content-center align-items-center"-->
                        <!--                            >-->
                        <!--                                <i class="fa fa-bed fa-2x mt-2"></i>-->
                        <!--                                <span class="h3 ml-3">{{ ro.name }}</span>-->
                        <!--                            </div>-->
                        <!--                            <div-->
                        <!--                                v-if="ro.status === 'OCUPADO'"-->
                        <!--                                class="text-center"-->
                        <!--                            >-->
                        <!--                                <i class="fa fa-user-tie fa-2x"></i>-->
                        <!--                                <span class="h6 ml-3">{{ ro.rent.customer.name }}</span>-->
                        <!--                                <p class="ml-3 text-white">Salida: {{ ro.rent.output_date }} / {{ ro.rent.output_time }}</p>-->
                        <!--                            </div>-->
                        <!--                        </el-card>-->
                    </div>
                </div>
            </div>
        </div>
        <ModalRoomRates
            :room="room"
            :visible.sync="openModalRoomRates"
            @onAddRoomRate="onAddRoomRate"
            @onDeleteRate="onDeleteRate"
        ></ModalRoomRates>
        <ExtendTimeRoom :room="roomToExtend"
                        :visible.sync="openDialogExtendTimeRoom"
                        @onRefresh="onRefresh">
        </ExtendTimeRoom>
    </div>
</template>
<style scope>
.btn-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}

.btn-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-warning {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107;
}

.btn-info {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
}
</style>
<script>
import ExtendTimeRoom from './partials/ExtendTimeRoom.vue';
import ModalRoomRates from "./RoomRates";
import XSelect from "../../../../components/Form/XSelect.vue";
import XInput from "../../../../components/Form/XInput.vue";
import XHotelRoom from "../../../../components/Hotel/Room.vue";

export default {
    components: {
        XHotelRoom,
        XInput,
        XSelect,
        ModalRoomRates,
        ExtendTimeRoom,
    },
    props: {
        roomStatus: {
            type: Array,
            required: true,
        },
        floors: {
            type: Array,
            required: true,
        },
        rooms: {
            type: Array,
            required: true,
            default: [],
        },
    },
    data() {
        return {
            loading: false,
            openModalRoomRates: false,
            openDialogExtendTimeRoom: false,
            hotel_floor_id: 'all',
            hotel_name_room: '',
            hotel_status_room: 'TODOS',
            // statusSelect: 'TODOS',
            items: [],
            room: null,
            roomToExtend: {},
        };
    },
    mounted() {
        this.items = this.rooms;
    },
    /*
    watch: {
        hotel_floor_id() {
            this.onFilterByStatus();
        },
    },
    */
    methods: {
        onFinalizeClean(room) {
            const text = `Está a punto de terminar la limpieza de la habitación ${room.name}`;
            this.$confirm(text, "Atención", {
                confirmButtonText: "Si",
                cancelButtonText: "No",
                type: "warning",
            })
                .then(() => {
                    this.loading = true;
                    const payload = {
                        status: "DISPONIBLE",
                    };
                    this.$http
                        .post(`/hotel/rooms/${room.id}/change-status`, payload)
                        .then((response) => {
                            room.status = "DISPONIBLE";
                            this.items = this.items.map((r) => {
                                if (r.id === room.id) {
                                    return room;
                                }
                                return r;
                            });
                            this.$message({
                                type: "success",
                                message: response.data.message,
                            });
                        })
                        .finally(() => (this.loading = false));
                })
                .catch();
        },
        onGoToCheckout(room) {
            window.location.href = `/hotel/receptions/rent/checkout/${room.rent.id}`;
        },
        onGoToAddProducts(room) {
            window.location.href = `/hotel/receptions/rent/products/${room.rent.id}`;
        },
        onDeleteRate(rateId) {
            this.room.rates = this.room.rates.filter((r) => r.id !== rateId);
        },
        onAddRoomRate(rate) {
            this.room.rates.push(rate);
        },
        onToRent(room) {
            if (room.rates.length > 0) {
                window.location.href = `/hotel/receptions/rent/${room.id}`;
            } else {
                this.room = room;
                this.openModalRoomRates = true;
            }
        },
        async searchRooms() {
            this.loading = true;
            let form = {
                hotel_status_room: this.hotel_status_room,
                hotel_name_room: this.hotel_name_room,
                hotel_floor_id: this.hotel_floor_id,
            }
            await this.$http
                .post("/hotel/receptions/search", form)
                .then((response) => {
                    // console.error(response.data)
                    if (this.hotel_status_room === 'RESERVADO' || this.hotel_status_room === 'DISPONIBLE') {
                        this.items = response.data.filter(row => {
                            return row.status === this.hotel_status_room
                        });
                    } else {
                        this.items = response.data;
                    }
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        onFilterByStatus(status = "") {
            // Si se presiona dos veces la misma opcion, se cancelaria
            // if (this.hotel_status_room == status) {
            //     this.hotel_status_room = null
            // } else {
            //     this.hotel_status_room = status
            // }
            this.searchRooms()
            return null;
            this.loading = true;
            const params = {
                status,
                hotel_floor_id: this.hotel_floor_id,
            };
            this.$http
                .get("/hotel/receptions", {params})
                .then((response) => {
                    this.items = response.data.rooms;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onGetColorStatus(status) {
            if (status === "DISPONIBLE") {
                return "btn-success";
            } else if (status === "MANTENIMIENTO") {
                return "btn-warning";
            } else if (status === "OCUPADO") {
                return "btn-danger";
            } else if (status === "LIMPIEZA") {
                return "btn-info";
            }
            return "";
        },
        showDialogExtendTimeRoom(room) {
            this.roomToExtend = room
            this.openDialogExtendTimeRoom = true
        },
        clickRoom(room) {
            if (room.status === 'DISPONIBLE') {
                this.onToRent(room)
            }
            if (room.status === 'LIMPIEZA') {
                this.onFinalizeClean(room)
            }
            if (room.status === 'OCUPADO') {
                this.onGoToCheckout(room)
            }
        },
        onRefresh() {
            this.searchRooms()
        }
    },
};
</script>
